import React from "react";
import PropTypes from "prop-types";
import "./FeeTypeSelector.css";
import IconRadioSelect from "../../../assets/icon_radio_select.svg";
import IconRadioUnselect from "../../../assets/icon_radio_unselect.svg";
import IconCheck from "../../../assets/icon_green_check.svg";
import { calculateEstimatedAmount, formatPrice } from "../../../util/util";
import { formatKoreanDate } from "../../../util/date";

/**
 * 수수료 선택
 * @param register
 * @param watch
 * @param feeWavedUntil
 * @returns {Element}
 * @constructor
 */
const FeeTypeSelector = ({ register, watch, feeWavedUntil }) => {
  const feeAssigned = watch("fee_assigned");
  const currentPrice = watch("price") || 0;
  const shippingFee = watch("shipping_fee") || 0;

  const today = new Date();
  const isFeeWaved =
    feeWavedUntil &&
    new Date(feeWavedUntil) >= new Date(today.setHours(0, 0, 0, 0));

  return (
    <div className="UserTypeSelector-container">
      <div className="UserTypeSelector-header">
        <h3>거래 수수료 부담 대상</h3>
      </div>
      {isFeeWaved ? (
        <div className="FeeTypeSelector-feeWaved">
          <img src={IconCheck} alt={"check"} />
          <span className="FeeTypeSelector-feeWaved-text">
            <span className="FeeTypeSelector-feeWaved-title">
              수수료 무료 혜택 적용 중
            </span>
            <span className="FeeTypeSelector-feeWaved-expire">
              만료일: {formatKoreanDate(feeWavedUntil)}
            </span>
          </span>
        </div>
      ) : (
        <>
          <div className="UserTypeSelector-options">
            <label className="UserTypeSelector-options-radio">
              <input
                type="radio"
                value="SELLER"
                {...register("fee_assigned", { required: true })}
                defaultChecked={feeAssigned === "SELLER"}
              />
              <div className="UserTypeSelector-options-radio-content">
                <img
                  src={
                    feeAssigned === "SELLER"
                      ? IconRadioSelect
                      : IconRadioUnselect
                  }
                  alt={feeAssigned === "SELLER" ? "선택됨" : "비선택"}
                  style={{ width: 28, height: 28 }}
                />
                <div className="option-text">
                  <span className="text">판매자(나)</span>
                  <span className="estimate-text">
                    예상 정산 금액:
                    {formatPrice(
                      calculateEstimatedAmount(
                        "SELLER",
                        currentPrice,
                        shippingFee,
                      ),
                    )}
                    원
                  </span>
                </div>
              </div>
            </label>
            <label className="UserTypeSelector-options-radio">
              <input
                type="radio"
                value="BUYER"
                {...register("fee_assigned", { required: true })}
                defaultChecked={feeAssigned === "BUYER"}
              />
              <div className="UserTypeSelector-options-radio-content">
                <img
                  src={
                    feeAssigned === "BUYER"
                      ? IconRadioSelect
                      : IconRadioUnselect
                  }
                  alt={feeAssigned === "BUYER" ? "선택됨" : "비선택"}
                  style={{ width: 28, height: 28 }}
                />
                <div className="option-text">
                  <span className="text">구매자</span>
                  <span className="estimate-text">
                    예상 정산 금액:
                    {formatPrice(
                      calculateEstimatedAmount(
                        "BUYER",
                        currentPrice,
                        shippingFee,
                      ),
                    )}
                    원
                  </span>
                </div>
              </div>
            </label>
          </div>
          <p className="UserTypeSelector-notice">
            판매자가 수수료 부담 대상을 자유롭게 선택할 수 있어요.
          </p>
        </>
      )}
    </div>
  );
};

FeeTypeSelector.propTypes = {
  register: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  feeWavedUntil: PropTypes.string,
};

export default FeeTypeSelector;
